import React from "react";
import SessionService from "../../services/ParentStation/SessionService";
import BabyStationListService from "../../services/ParentStation/BabyStationListService";
import useServiceState from "../../hooks/useServiceState";
import { Session } from "../../services/ParentStation/types";

interface Props {
    disabled: boolean;
    session_service: SessionService;
    baby_station_list_service: BabyStationListService;
}

const BabyStationDropdown: React.FunctionComponent<Props> = ({ disabled, session_service, baby_station_list_service }) => {
    const session_state = useServiceState(session_service);
    useServiceState(baby_station_list_service);

    const active_session: Session | null = React.useMemo(() => session_service.get_active_session(), [session_service, session_state]);

    const baby_stations = baby_station_list_service.list_baby_stations();

    const handle_change = React.useCallback((event: React.ChangeEvent<HTMLSelectElement>) => {
        if (disabled) return;
        session_service.leave_session();
        const session_id = event.target.value;
        const baby_station = baby_stations.find((session) => session.session.id === session_id);
        if (baby_station === undefined) return;
        session_service.join_session(baby_station);
    }, [disabled, session_service, baby_stations]);

    if (baby_stations.size === 0) return (
        <div id="alert-no-baby-stations" className="alert alert-info" role="alert">
            No baby stations available
        </div>
    );

    const active_session_id = active_session?.id ?? "";
    return (
        <div className="mb-3">
            <select disabled={disabled} id="baby-station-dropdown" value={active_session_id} onChange={handle_change} className="form-select">
                {baby_stations.map((baby_station) => (
                    <option value={baby_station.session.id} key={baby_station.session.id}>
                        {baby_station.session.name}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default BabyStationDropdown;
